import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
  
} from '@react-pdf/renderer';
import { dateFormatter } from '../../../../../utils';
import React from "react";
import JsBarcode from "jsbarcode";
import QRCode from "qrcode";


Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});


const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  row1: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '14.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '13.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  tableCell: {
    fontSize: 10
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const COLORS = ['#ffffff', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const OPDBillingPDF = ({ data, isPublic = false }) => {
  const [barcodeImg, setBarcodeImg] = React.useState("");
  const [qrImg, setQrImg] = React.useState("");
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [isDownloaded, setIsDownloaded] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  // console.log("Console Data --- ", data);
  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const user = JSON.parse(localStorage.getItem('user'));
  const currentDate = new Date();
  // Get date components
  const day = currentDate.getDate().toString().padStart(2, '0');
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
  const year = currentDate.getFullYear();

  // Get time components
  const hours = currentDate.getHours().toString().padStart(2, '0');
  const minutes = currentDate.getMinutes().toString().padStart(2, '0');
  const seconds = currentDate.getSeconds().toString().padStart(2, '0');



 


  React.useEffect(() => {
    if (!data || typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);
    const refId = params.get("refId");

    // BARCODE
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, String(data.receiptNo), {
      format: "CODE128",
      displayValue: false,
      height: 40
    });
    setBarcodeImg(canvas.toDataURL());
    let path;
    // QR → PUBLIC LINK
    if (refId) {
      if (isPublic) {
        path = window.location.pathname;
      } else {
        path = window.location.pathname.replace("/print/", "/public/print/");
      }
      const qrUrl = `${window.location.origin}${path}?refId=${refId}`;
      QRCode.toDataURL(qrUrl).then(setQrImg);
    }
  }, [data, isPublic]);


  const downloadPDF = async () => {
    try {
      // Import pdf dynamically to avoid SSR issues
      const { pdf } = await import('@react-pdf/renderer');
      const blob = await pdf(PdfDoc).toBlob();
      const url = URL.createObjectURL(blob);

      // Create download link
      const link = document.createElement('a');
      link.href = url;
      link.download = `OPD-Bill-${data.receiptNo || Date.now()}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      setTimeout(() => {
        URL.revokeObjectURL(url);
        setIsDownloading(false);

        // Show success message instead of trying to close
        setIsDownloaded(true);
      }, 100);

    } catch (error) {
      console.error('Error downloading PDF:', error);
      setIsDownloading(false);
      setIsError(true);
      //alert('Failed to download PDF. Please try again.');
    }
  };


  React.useEffect(() => {
    if (isPublic && data && barcodeImg && qrImg && !isDownloading) {
      // Small delay to ensure everything is loaded
      const timer = setTimeout(() => {
        downloadPDF();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isPublic, data, barcodeImg, qrImg, isDownloading]);

  const PdfDoc = (
    <Document title={`Opd Service Invoice`}>
      <Page size="A4" style={styles.page}>
        <PDFImage
          src="/logo_Hospital_m.jpeg"
          style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
        />
        <View style={styles.row}>
          <Text content="OPD Procedure / Service Detailed Receipt" style={{ fontSize: '12px', margin: '0 auto', fontFamily: "Roboto" }} />
        </View>
        <View style={{ flexDirection: "row", justifyContent: "space-between", marginTop: 12, marginBottom: 2 }}>
          {barcodeImg && (
            <PDFImage
              src={barcodeImg}
              style={{ width: 130, height: 40 }}
            />
          )}

          {qrImg && (
            <PDFImage
              src={qrImg}
              style={{ width: 70, height: 70 }}
            />
          )}
        </View>
        <View style={styles.contentContainer}>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text content="Reciept No   :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.receiptNo}`} />
            </View>
            <View style={styles.row}>
              <Text content="Uhid No.       :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.uhid}`} />
            </View>
            <View style={styles.row}>
              <Text content="Date/Time   :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${formatDate(data.billing_date)}${data.billing_time}`} />
            </View>
            <View style={styles.row}>
              <Text content="Ref By          :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data?.ref_by}`} />
            </View>
          </View>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text content="Patient Name  :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.patientName}`} />
            </View>
            <View style={styles.row}>
              <Text content="Age/Sex           :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.age} / ${data.gender}`} />
            </View>
            <View style={styles.row}>
              <Text content="Mobile              :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.mobile}`} />
            </View>
            <View style={{ ...styles.row, width: "76%" }}>
              <Text content="Address           :                " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.address}`} />
            </View>
          </View>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text content="Guardian       :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data?.guardian}`} />
            </View>
            <View style={styles.row}>
              <Text content="Consultant    :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data?.doctor}`} />
            </View>
            <View style={styles.row}>
              <Text content="Department  :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.department}`} />
            </View>
            <View style={styles.row}>
              <Text content="Sponsor        :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.sponsor}`} />
            </View>
          </View>
        </View>

        {/* Table */}
        <View style={styles.row1}>
          <Text style={{ ...styles.columnHeader, width: '10%' }} content="Sr No." />
          <Text style={{ ...styles.columnHeader, width: '35%' }} content="Services" />
          <Text style={{ ...styles.columnHeader, width: '5%' }} content="Qty" />
          <Text style={{ ...styles.columnHeader, width: '10%' }} content="Rate" />
          <Text style={{ ...styles.columnHeader, width: '15%' }} content="Amount" />
          <Text style={{ ...styles.columnHeader, width: '10%' }} content="Disc" />
          <Text style={{ ...styles.columnHeader, width: '15%' }} content="Net Amount" />
        </View>
        {data.services &&
          data?.services?.map((service, index) => (
            <View key={index} style={{ ...styles.row1, backgroundColor: COLORS[index % COLORS.length] }}>
              <Text style={{ ...styles.columnContent, width: '12%' }} content={index + 1} />
              <Text
                style={{
                  ...styles.columnContent,
                  textAlign: 'start',
                  width: '35%',
                  flexWrap: 'wrap',
                  overflow: 'hidden'
                }}
                content={service.service_name}
              />
              <Text style={{ ...styles.columnContent, width: '5%' }} content={`${service.quantity}`} />
              <Text style={{ ...styles.columnContent, width: '10%', textAlign: 'right' }} content={service.rate} />
              <Text style={{ ...styles.columnContent, width: '15%', textAlign: 'right' }} content={service.amount} />
              <Text
                style={{ ...styles.columnContent, width: '10%', textAlign: 'right' }}
                content={service.disc_amt}
              />
              <Text
                style={{ ...styles.columnContent, width: '15%', textAlign: 'right', marginRight: '10px' }}
                content={service.net_amt}
              />
            </View>
          ))}
        <View style={styles.contentContainer2}>
          <View style={styles.column}>
            {/* <View style={styles.row}>
                <Text content="Total Amount    :    " style={styles.textBold} />
                <Text content={`${data.total_amt}`} />
              </View> */}
            {/* <View style={styles.row}>
                <Text content="Net Amt            :    " style={styles.textBold} />
                <Text content={`${data.net_amt}`} />
              </View> */}
            <View style={{ ...styles.row, marginTop: '20px' }}>
              <Text content="Remarks  :    " style={styles.textBold} />
              <Text content={`${''}`} />
            </View>
            <View style={{ marginTop: '25px' }}>
              <Text content={`Received With Thanks From : ${data.patientName}.`} style={{ width: '320px' }} />
            </View>
            <View style={{ marginTop: '5px' }}>
              <Text
                content={'Note : Refund if any, will be made against surrender of Original Receipt only !'}
                style={{ width: '320px' }}
              />
            </View>

            {/* <View style={{ ...styles.column, marginTop: '5px' }}>
                <View style={styles.row}>
                  <Text content={`Print Date  :  ${currentTime}`} />
                  <Text content={`Print Time  :   [ ${hours}:${minutes}:${seconds} ]`} />
                </View>
              </View> */}
          </View>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text content="Pay Mode       :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.pay_mode || 'N/A'}`} />
            </View>
            <View style={styles.row}>
              <Text content="Recd Amt       :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
            </View>
            {(data.pay_mode === 'CASH' || data.pay_mode === 'Both') && (
              <View style={styles.row}>
                <Text content="  Cash            :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
                <Text content={`${data.rec_amt_1 || '0'}`} />
              </View>
            )}
            {['Bank', 'UPI', 'Paytm', 'RTGS/NEFT', 'Cheque', 'Credit Card', 'Debit Card', 'Both'].includes(data.pay_mode) && (
              <View style={styles.row}>
                <Text content="  Bank/UPI     :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
                <Text content={`${data.rec_amt_2 || '0'}`} />
              </View>
            )}
            <View style={{ ...styles.row, marginTop: '10px' }}>
              <Text content="Printed By       :   " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${user?.name || "N/A"}`} />
            </View>
          </View>
          <View style={styles.column}>
            <View style={styles.row}>
              <Text content="Total Amount              :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.total_amt}`} />
            </View>
            <View style={styles.row}>
              <Text content="Bill Discount               :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.disc_amt}`} />
            </View>
            <View style={styles.row}>
              <Text content="Service Discount       :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.service_disc}`} />
            </View>
            <View style={styles.row}>
              <Text content="Net Amt                       :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.net_amt}`} />
            </View>
            <View style={styles.row}>
              <Text content="Balance Amt               :    " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text content={`${data.balance_amt}`} />
            </View>

            <View style={{ marginTop: '19px' }}>
              <Text content="Received By     : " style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text style={styles.textUnderlined} />
            </View>
            <View style={{ marginTop: '16px' }}>
              <Text content="Authorised Signatory :" style={{ ...styles.textBold, fontFamily: "Roboto" }} />
              <Text style={styles.textUnderlined} />
              <View style={{ marginTop: '10px' }}>
                <Text
                  content={`Printed Date and Time - ${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`}
                  style={{ width: '180px' }}
                />
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );


  if (isPublic) {
    return (
      <div style={{
        backgroundColor: "white",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        textAlign: "center"
      }}>
        <div style={{ marginBottom: "20px" }}>
          <img
            src="/logo_Hospital_m.jpeg"
            alt="Hospital Logo"
            style={{ width: "200px", height: "80px", objectFit: "contain" }}
          />
        </div>

        {isDownloaded ? (
          <div style={{
            padding: "30px",
            backgroundColor: "#f0f9f0",
            borderRadius: "8px",
            maxWidth: "400px",
            border: "1px solid #4CAF50"
          }}>
            <div style={{ fontSize: "24px", color: "#4CAF50", marginBottom: "15px" }}>
              ✓
            </div>
            <div style={{ fontSize: "18px", fontWeight: "bold", color: "#4CAF50", marginBottom: "10px" }}>
              PDF Downloaded Successfully!
            </div>
            <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
              Your bill has been downloaded. You can now close this window.
            </p>
            <button
              onClick={() => window.location.href = "about:blank"}
              style={{
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
                marginTop: "10px"
              }}
            >
              Close This Page
            </button>
          </div>
        ) : isError ? (
          <div style={{
            padding: "30px",
            backgroundColor: "#fff5f5",
            borderRadius: "8px",
            maxWidth: "400px",
            border: "1px solid #f44336"
          }}>
            <div style={{ fontSize: "24px", color: "#f44336", marginBottom: "15px" }}>
              ✗
            </div>
            <div style={{ fontSize: "18px", fontWeight: "bold", color: "#f44336", marginBottom: "10px" }}>
              Download Failed
            </div>
            <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
              Failed to download PDF. Please try again.
            </p>
            <button
              onClick={downloadPDF}
              style={{
                backgroundColor: "#1976D2",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "bold",
                marginTop: "10px"
              }}
            >
              Try Again
            </button>
          </div>
        ) : (
          <div style={{
            padding: "20px",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
            maxWidth: "400px"
          }}>
            <div style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "15px" }}>
              {isDownloading ? "Downloading PDF..." : "Preparing PDF for download..."}
            </div>

            {isDownloading && (
              <div style={{ margin: "20px 0" }}>
                <div style={{
                  width: "40px",
                  height: "40px",
                  border: "4px solid #f3f3f3",
                  borderTop: "4px solid #1976D2",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto"
                }} />
                <style>
                  {`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}
                </style>
              </div>
            )}

            <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
              Your bill will download automatically.
            </p>

            {!isDownloading && (
              <button
                onClick={downloadPDF}
                style={{
                  backgroundColor: "#1976D2",
                  color: "white",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                  marginTop: "10px"
                }}
              >
                Click to Download
              </button>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      {PdfDoc}
    </PDFViewer>
  );
};
